import toCamelCase from '../toCamelCase';

export default function getSummaryBlockData(props) {
  const {
    fields: { whatYoullLearn, whatYoullNeed },
  } = props;

  const data = {};

  data.sections = whatYoullLearn || whatYoullNeed ? [] : false;
  if (data.sections) {
    const learnings = whatYoullLearn ? {} : false;
    if (learnings) {
      learnings.title = 'What you’ll learn';
      learnings.id = toCamelCase('What youll learn');
      learnings.list = whatYoullLearn;
      data.sections.push(learnings);
    }

    const requirements = whatYoullNeed ? {} : false;
    if (requirements) {
      requirements.title = 'What you’ll need';
      requirements.id = toCamelCase('What youll need');
      requirements.list = whatYoullNeed;
      data.sections.push(requirements);
    }
  }

  if (data.sections.length >= 1) {
    data.buttons = [];

    data.buttons.share = [];
    const sharebutton = {};
    sharebutton.label = 'Share this playbook';
    sharebutton.type = 'share';
    sharebutton.modifier = 'Button--electricPurpleFill';
    data.buttons.push(sharebutton);

    // data.buttons.download = [];
    // const downloadButton = {};
    // downloadButton.label = 'Download this playbook';
    // downloadButton.type = 'download';
    // downloadButton.modifier = 'Button--electricPurple';
    // data.buttons.push(downloadButton);
  }

  return Object.keys(data).length ? data : false;
}
